import React, { useState } from "react";
import "./header.css";
import headerLogoImage from "../assets/image/headerLogoImage.png";
import { Avatar, Box, IconButton, Menu, MenuItem, Typography, useMediaQuery } from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import CommonTooltip from "./CommonTooltip";


const Header = ({userName})=>{
    const navigate = useNavigate();
    const isMobile = useMediaQuery('(max-width: 600px)');
    
    const handleLogout = () => {
        // Clear authentication data from Cookies
        Cookies.remove("fytn_token");
        Cookies.remove("fytn_user");
        
        // Clear authentication data from sessionStorage
        sessionStorage.removeItem("fytn_token");
        sessionStorage.removeItem("resultsData");
        
        // Note: We don't clear localStorage to preserve UI preferences like sidebarCollapsed
        // Only clear auth-related localStorage items if any exist
        // localStorage.clear(); // Removed - too aggressive, clears UI preferences
        
        navigate("/login");
    };

    console.log("Header component rendered with userName:", userName);
    return(
    <header className="App-header">
    <img src={headerLogoImage} alt="Logo" className="App-logo" />
       <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 1, sm: 2 } }}>
       {userName && typeof userName === 'string' && userName.trim() && (
         <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 0.5, sm: 1 } }}>
            <Avatar alt={userName} sx={{ width: { xs: 32, sm: 40 }, height: { xs: 32, sm: 40 } }}>
              {userName.charAt(0).toUpperCase()}
            </Avatar>
            <Typography 
              variant="subtitle1" 
              fontWeight="500"
              sx={{ 
                display: { xs: 'none', sm: 'block' } // Hide text on mobile, show on larger screens
              }}
            >
              {userName}
            </Typography>
          </Box>
       )}
         {userName && typeof userName === 'string' && userName.trim() && (
           <CommonTooltip title="Logout" placement="bottom">
             <IconButton
               color="error"
               onClick={handleLogout}
               size={isMobile ? "small" : "medium"}
               sx={{
                 "&:hover": {
                   backgroundColor: "rgba(211, 47, 47, 0.08)",
                 },
               }}
             >
               <LogoutIcon />
             </IconButton>
           </CommonTooltip>
         )}
       </Box>
  </header>
    )


};

export default Header;
